'use strict';
module Patersons {

    export interface EquitiesResearchScope extends ng.IScope {
        events: EquitiesResearchCtrl;

    }

    export class EquitiesResearchCtrl extends ResearchBaseCtrl  {
        scope: Patersons.EquitiesResearchScope;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;

            this.load();
        }
        load(){
            let self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                    initComponent('component-stockScreener', 'ecScreener-container', 'ec-screener', 'ecScreener_stock').then(function () {
                        console.log("Loaded screener");
                    });
            });
        }
    }
}